module.exports = __webpack_public_path__ + "files/230b39e4fcaac0bf1cdd940cb5e5a6ca.png";